import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  CardContent,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { message } from "antd";
import { useParams, useNavigate } from "react-router-dom";

const PostTuition = () => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const { id } = useParams();
  const navigate = useNavigate();
  const [tuition_fee, setTuition_fee] = React.useState("");
  const [discount_amount, setDiscount_amount] = React.useState("");
  const [reason, setReason] = React.useState("");
  const token = localStorage.getItem("token");
  const direction = ["ar", "ku"].includes(i18n.language) ? "rtl" : "ltr";
  const textAlign = ["ar", "ku"].includes(i18n.language) ? "right" : "left";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("tuition_fee", tuition_fee);
      formData.append("discount_amount", discount_amount);
      formData.append("reason", reason);
      formData.append("discount_type", "currency");
      await axios.post(
        `https://api.clever-school.com/api/students/${id}/create-tuition`,
        formData,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      message.success(t("tuitionUpdated"));
      navigate("/GetStudent");
    } catch (error) {
      message.error(t("tuitionUpdateFailed"));
      console.error("Submission error:", error);
    }
  };

  const handleReset = () => {
    setTuition_fee("");
    setReason("");
    setDiscount_amount("");
  };
  const formFieldStyles = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#f5f5f5",
      borderRadius: "8px",
      "& fieldset": { border: "none" },
      "&:hover fieldset": { border: "none" },
      "&.Mui-focused fieldset": {
        border: "none",
        boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
      },
    },
    "& .MuiInputBase-input": {
      padding: "12px 14px",
    },
  };

  return (
    <Box
      sx={{
        maxWidth: 1200,
        margin: "40px auto",
        padding: theme.spacing(3),
        [theme.breakpoints.down("sm")]: { padding: theme.spacing(2) },
        direction,
        textAlign,
      }}
    >
      <Paper
        elevation={2}
        sx={{
          borderRadius: 4,
          padding: theme.spacing(4),
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mb: 3 }}>
            {t("postTuition")}
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("tuitionFee")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={tuition_fee}
                  onChange={(e) => setTuition_fee(e.target.value)}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12} md={6}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("discountAmount")}
                </Typography>
                <TextField
                  fullWidth
                  type="number"
                  value={discount_amount}
                  onChange={(e) => setDiscount_amount(e.target.value)}
                  variant="outlined"
                  required
                  sx={formFieldStyles}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12}>
              <CardContent>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  gutterBottom
                >
                  {t("reason")}
                </Typography>
                <TextField
                  fullWidth
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  variant="outlined"
                  multiline
                  sx={formFieldStyles}
                  rows={3}
                />
              </CardContent>
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  onClick={handleReset}
                  sx={{
                    px: 4,
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                >
                  {t("reset")}
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => navigate("/GetStudent")}
                  sx={{
                    px: 4,
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                >
                  {t("cancel")}
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    px: 6,
                    borderRadius: 2,
                    textTransform: "none",
                  }}
                >
                  {t("submit")}
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export default PostTuition;
